<i id="delete" (click)="btnClickedHandler()" class="ra-icon-ide-sm-delete ft-hub-cp"></i>
